import $ from 'jquery';
import 'jquery.easing';

import { LG_BREAKPOINT } from '../constants/constants';

const $window = $(window);
const $tabs = $('.tabs-accord');

$tabs.each((_, el) => {
  const $el = $(el);
  const $refContainer = $el.find('.tabs-accord-bar-ref-container'); // used to calculate responsive width
  const $scroller = $el.find('.tabs-accord-bar-scroller');
  const $tabBarList = $el.find('.tabs-accord-bar-list');
  const $tabBtns = $el.find('.tabs-accord-bar-btn');
  const $prevBtn = $el.find('.tabs-accord-bar-control-prev');
  const $nextBtn = $el.find('.tabs-accord-bar-control-next');
  const $toggleBtns = $el.find('.tabs-accord-content-toggle-btn');
  const $contentItems = $el.find('.tabs-accord-content-item');
  const isFullWidth = $el.hasClass('tabs-accord-full-width');
  let currentIndex = null;
  let windowWidth = 0;
  let isMobile = true;

  // Track window size
  // ------------------------------------------------------------------------ //
  function checkWindowSize() {
    windowWidth = $window.width();

    if (windowWidth >= LG_BREAKPOINT) {
      isMobile = false;
    } else {
      isMobile = true;
    }

    // Show/hide the tab bar prev/next arrows
    if ($tabBarList.outerWidth() > $scroller.outerWidth()) {
      $el.addClass('is-scrollable');
    } else {
      $el.removeClass('is-scrollable');
    }
  }
  $window.resize(() => {
    checkWindowSize();
  });

  // Do this first time page loads
  checkWindowSize();

  // Tab/Accordion Functionality
  // ------------------------------------------------------------------------ //
  function hideItem(itemIndex) {
    if (itemIndex !== null) {
      const $item = $($contentItems[itemIndex]);
      const $body = $item.find('.tabs-accord-content-body');

      if (isMobile) {
        // Accordion functionality for mobile
        $item.removeClass('is-current');
        $($tabBtns[itemIndex]).removeClass('is-current');
        // WCAG
        $($toggleBtns[itemIndex]).attr('aria-selected', false);
        $($toggleBtns[itemIndex]).attr('tabindex', '-1');
        // Animate the height of the alert section
        $body.animate({ height: 0 }, 400, 'easeOutQuad', () => {
          // Hide alert on screen
          $item.removeClass('is-on-screen');
          // clear out the inline styles so things work responsively
          $body.attr('style', '');
        });
      } else {
        $item.removeClass('is-current');
        $($tabBtns[itemIndex]).removeClass('is-current');
        // WCAG
        $($tabBtns[itemIndex]).attr('aria-selected', false);
        $($tabBtns[itemIndex]).attr('tabindex', '-1');
        $item.removeClass('is-on-screen');
      }
      // If hiding the current item reset the currentIndex
      if (itemIndex === currentIndex) {
        currentIndex = null;
      }
    }
  }

  function showItem(itemIndex) {
    const $item = $($contentItems[itemIndex]);
    const $body = $item.find('.tabs-accord-content-body');
    if (isMobile) {
      // Accordion functionality for mobile
      // Get height of body
      // (which is absolutely positioned off the left of the screen)
      const height = $body.outerHeight();
      // Make height 0
      $body.css('height', 0);
      // Bring body onto the screen
      $item.addClass('is-current');
      $item.addClass('is-on-screen');
      // Update the current tab
      $($tabBtns[itemIndex]).addClass('is-current');
      // WCAG
      $($toggleBtns[itemIndex]).attr('aria-selected', true);
      $($toggleBtns[itemIndex]).removeAttr('tabindex');;
      // Animate the height of the body
      $body.animate({ height }, 400, 'easeOutQuad', () => {
        // clear out the inline styles so things work responsively
        $body.attr('style', '');
      });
    } else {
      $item.addClass('is-current');
      $item.addClass('is-on-screen');
      $($tabBtns[itemIndex]).addClass('is-current');
      // WCAG
      $($tabBtns[itemIndex]).attr('aria-selected', true);
      $($tabBtns[itemIndex]).removeAttr('tabindex');
    }
    // Hide the current item
    hideItem(currentIndex);
    // Update the index
    currentIndex = itemIndex;
  }

  function toggleItem(itemIndex) {
    // Hide item if the item is already visible
    if (itemIndex === currentIndex) {
      hideItem(itemIndex);
      // Otherwise show it
    } else {
      showItem(itemIndex);
    }
  }

  // The accordion toggle buttons that are only visible on mobile/tablet
  $toggleBtns.each((btnIndex, btnEl) => {
    const $btn = $(btnEl);
    $btn.click(e => {
      // get element and scroll to it
      var accordionScrollEl = document.getElementById($btn.parent('a').attr('data-scroll-id'));
      if (accordionScrollEl) {
        accordionScrollEl.scrollIntoView();
      }
      // scroll to adjust for fixed header on mobile
      if (document.getElementsByClassName('header-top')[0]) {
        window.scrollTo(window.scrollX, window.scrollY - document.getElementsByClassName('header-top')[0].offsetHeight);
      }
      e.preventDefault();
      toggleItem(btnIndex);
    });
  });

  // The tab bar buttons that are only visible on desktop
  $tabBtns.each((btnIndex, btnEl) => {
    const $btn = $(btnEl);
    $btn.click(e => {
      // get element and scroll to it
      var tabScrollEl = document.getElementById($btn.parent('a').attr('data-scroll-id'));
      if (tabScrollEl) {
        tabScrollEl.scrollIntoView();
      }
      e.preventDefault();
      if (btnIndex !== currentIndex) {
        showItem(btnIndex);
      }
    });
  });

  // Show the first item
  showItem(0);

  // Tab bar scroll functionality
  // ------------------------------------------------------------------------ //
  function scrollTabBar(direction) {
    let newScrollLeft = 0;
    if (direction === 'right') {
      newScrollLeft = $scroller.scrollLeft() + windowWidth / 2;
    } else {
      newScrollLeft = $scroller.scrollLeft() - windowWidth / 2;
    }

    $scroller.animate({ scrollLeft: newScrollLeft }, 400, 'easeInOutQuad');
  }

  function checkScrollPosition() {
    const scrollLeft = $scroller.scrollLeft();
    if (scrollLeft > 0) {
      $prevBtn.addClass('is-enabled');
    } else {
      $prevBtn.removeClass('is-enabled');
    }

    if (scrollLeft < $tabBarList.outerWidth() - windowWidth) {
      $nextBtn.addClass('is-enabled');
    } else {
      $nextBtn.removeClass('is-enabled');
    }
  }

  $scroller.on('scroll', () => {
    checkScrollPosition();
  });

  checkScrollPosition();

  $prevBtn.click(e => {
    e.preventDefault();
    scrollTabBar('left');
  });

  $nextBtn.click(e => {
    e.preventDefault();
    scrollTabBar('right');
  });
});
